import { useSwipeable } from 'react-swipeable';

export function useSwipeHandlers({ slideBack, slideNext }: { slideNext: () => void; slideBack: () => void }) {
	return useSwipeable({
		swipeDuration: 800,
		trackMouse: true,
		trackTouch: true,
		delta: 10,
		preventScrollOnSwipe: true,
		onSwipedLeft: slideNext,
		onSwipedRight: slideBack,
	});
}
